
import { computed, toRefs, inject, reactive, ref } from "vue";
import { useRouter } from "vue-router";


export default {
  props: {
    item: {
      type: Array,
      default: []
    },

    //领劵按钮
    securities_func: {
      type: Function,
      default: () => {},
    },
    details_voucher_state: {
      type: Boolean,
      default: false,
    },
    isShowUseBtn: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
    },
  },
  setup(props: any, { emit }: any) {
    const router = useRouter();
    let { item } = toRefs(props);
    const $store: any = inject("$store");
    const currencyUnit = $store.getSymbol();
    let preserve: any = ref([]);

    const get_voucher_type_name = computed(() => {
      switch(item.value.voucher_type) {
        case 2:
          return 'Airtime Voucher'
          break;
        case 3:
          return 'Shipping Voucher'
          break;
        case 7:
          return 'Data Voucher'
          break;
        default:
          return 'Goods Voucher'
          break
      }
    })

    

    //优惠券标题
    let get_coupons_title_fn = computed(() => {
      if (item.value.voucher_seller_use_type === 1) {
        //立减
        if (item.value.voucher_seller_settlement_type === 1) {
          //折扣
          return item.value.voucher_price + "% OFF";
        } else {
          //减价格
          return (
            currencyUnit + " " + parseInt(item.value.voucher_price) + " OFF"
          );
        }
      } else {
        //满减
        if (item.value.voucher_seller_settlement_type === 1) {
          //折扣
          return item.value.voucher_price + "% OFF";
        } else {
          //减价格
          return (
            currencyUnit + " " + parseInt(item.value.voucher_price) + " OFF"
          );
        }
      }
    });

    //优惠券的内容
    let get_coupons_content_fn = computed(() => {
      if (item.value.voucher_seller_use_type === 1) {
        //立减
        if (item.value.voucher_seller_settlement_type === 1) {
          //折扣
          return (
            "Can be redeemed on orders above " +
            currencyUnit +
            "." +
            parseInt(item.value.voucher_limit) +
            " in <b>" +
            (item.value.voucher_store_name
              ? item.value.voucher_store_name
              : "Kilimall") +
            "</b>  only."
          );
        } else {
          //减价格
          return (
            "Can be redeemed on orders above " +
            currencyUnit +
            "." +
            parseInt(item.value.voucher_limit) +
            " in <b>" +
            (item.value.voucher_store_name
              ? item.value.voucher_store_name
              : "Kilimall") +
            "</b>  only."
          );
        }
      } else {
        //满减
        if (item.value.voucher_seller_settlement_type === 1) {
          //折扣
          return (
            "Can be redeemed on all orders above " +
            currencyUnit +
            "." +
            parseInt(item.value.voucher_limit) +
            " in <b>" +
            (item.value.voucher_store_name
              ? item.value.voucher_store_name
              : "Kilimall") +
            "</b>  only."
          );
          // return 'Can be redeemed on all orders in <b>' + (item.value.voucher_store_name ? item.value.voucher_store_name : 'Kilimall') + '</b>  only.'
        } else {
          //减价格
          return (
            "Can be redeemed on orders above " +
            currencyUnit +
            " " +
            parseInt(item.value.voucher_limit) +
            " in <b>" +
            (item.value.voucher_store_name
              ? item.value.voucher_store_name
              : "Kilimall") +
            "</b> only."
          );
        }
      }
    });

    //领劵
    let securities_func = (val: number) => {
      emit("get_voucher_fn", val);
      preserve.value.push(val);
    };
    
    let click_coupons_fn = (item: any) => {
      if (item.voucher_state != "1") {
        return;
      }
      if (item.voucher_type == 0) {
        //店铺券  --跳转店铺
        router.push({
          name: "shop",
          params: {
            id: item.voucher_store_id,
          },
        });
      } else if (item.voucher_type == 1) {
        //平台券  --跳转首页
        router.push("/");
      } else if (item.voucher_type == 2 || item.voucher_type == 3 || item.voucher_type == 6 || item.voucher_type == 7 ) {
        // 话费券、运费券、平台品类券、流量券提示下载APP
        emit("update:isShowDownload", true);
      } else if (item.redirect_type == 4) {
        //跳转到搜索列表
        router.push({
          path: "/search",
          query: {
            bind_cid: item.redirect_type_value.gc_id,
            bind_keywords: item.redirect_type_value.gc_name,
          },
        });
      } else {
        router.push("/");
      }
    };
    let use_type = item.value.voucher_seller_use_type; //0:满减;1:立减(无门槛)
    let seller_type = item.value.voucher_seller_type; //0:通用;1:商品组(单品或者多品);2:分类(品类);3:品牌
    let settlement_type = item.value.voucher_seller_settlement_type; //0:减金额;1:折扣

    //标题
    let get_coupons_title_fns = computed(() => {
      if (item.value.voucher_type == 0) {
        //商家
        if (settlement_type === 0) {
          //金额劵
          return `${currencyUnit} ${parseInt(item.value.voucher_price)} OFF`;
        } else {
          return `${parseInt(item.value.voucher_price)}% OFF`;
        }
      } else {
        //平台
        return currencyUnit + " " + parseInt(item.value.voucher_price) + " OFF";
      }
    });

    let get_coupons_content_fns = computed(() => {
      if (item.value.voucher_type == 0) {
        //商家
        if (use_type === 1) {
          //无门槛类型
          if (seller_type === 1) {
            //单多品金额劵 || 单多品折扣
            return `Available in Some products in store ${
              item.value.voucher_store_name
                ? item.value.voucher_store_name
                : "Kilimall"
            }`;
          } else if (seller_type === 2) {
            //品类金额 || 品类折扣
            return `Available in${
              item.value.voucher_title ? item.value.voucher_title : "Kilimall"
            } products in store ${
              item.value.voucher_store_name
                ? item.value.voucher_store_name
                : "Kilimall"
            }`;
          } else {
            //无门槛立减金额 || 无门槛折扣
            return `Available in store ${
              item.value.voucher_store_name
                ? item.value.voucher_store_name
                : "Kilimall"
            } `;
          }
        } else {
          //满减类型
          if (seller_type === 1) {
            //单多品金额劵 || 单多品折扣
            return `Available above ${currencyUnit} ${parseInt(
              item.value.voucher_limit
            )} in Some products in store ${
              item.value.voucher_store_name
                ? item.value.voucher_store_name
                : "Kilimall"
            }`;
          } else if (seller_type === 2 && settlement_type == 0) {
            //品类金额
            return `Available above ${currencyUnit} ${parseInt(
              item.value.voucher_limit
            )} in ${
              item.value.voucher_title ? item.value.voucher_title : "Kilimall"
            } products in store ${
              item.value.voucher_store_name
                ? item.value.voucher_store_name
                : "Kilimall"
            }`;
          } else if (seller_type === 2 && settlement_type == 1) {
            //品类折扣
            return `Available  for  products above ${currencyUnit} ${parseInt(
              item.value.voucher_limit
            )} in ${
              item.value.voucher_title ? item.value.voucher_title : "Kilimall"
            } products in store ${
              item.value.voucher_store_name
                ? item.value.voucher_store_name
                : "Kilimall"
            } `;
          } else {
            //满减金额 和折扣
            return `Available above ${currencyUnit} ${parseInt(
              item.value.voucher_limit
            )} in store ${
              item.value.voucher_store_name
                ? item.value.voucher_store_name
                : "Kilimall"
            }`;
          }
        }
      } else if (item.value.voucher_type == 3) {
        //平台运费劵
        if (item.value.voucher_shipping) {
          //文案 根据6个字段来判断物流和商品的状态
          let is_ds = item.value.voucher_shipping.voucher_t_is_ds;
          let is_fbk = item.value.voucher_shipping.voucher_t_is_fbk;
          let is_gs = item.value.voucher_shipping.voucher_t_is_gs;
          let is_delivery = item.value.voucher_shipping.voucher_t_is_delivery;
          let is_kili_agent =
            item.value.voucher_shipping.voucher_t_is_kili_agent;
          let is_other_pick =
            item.value.voucher_shipping.voucher_t_is_other_pick;
          if (is_ds == 1 && is_fbk == 1 && is_gs == 1) {
            //所有物流
            if (is_delivery == 1 && is_kili_agent == 1 && is_other_pick == 1) {
              //所有物流&所有商品
              return "Available for all logistics methods & all products";
            } else {
              //所有物流&部分商品
              return `Available for products of fulfilled by ${
                is_delivery == 1
                  ? is_kili_agent == 1 || is_other_pick == 1
                    ? "Doorstep/"
                    : "Doorstep"
                  : ""
              } ${
                is_kili_agent == 1
                  ? is_other_pick == 1
                    ? "Kilishop/"
                    : "Kilishop"
                  : ""
              } ${is_other_pick == 1 ? "G4S" : ""} `;
            }
          } else {
            if (is_delivery == 1 && is_kili_agent == 1 && is_other_pick == 1) {
              //部分物流&所有商品
              return `Available for products deliver to  ${
                is_ds == 1
                  ? is_fbk == 1 || is_gs == 1
                    ? "local dispatch/"
                    : "local dispatch"
                  : ""
              } ${is_fbk == 1 ? (is_gs == 1 ? "Kilimall/" : "Kilimall") : ""} ${
                is_gs == 1 ? "oversea shipment" : ""
              }`;
            } else {
              //部分物流 & 部分商品
              return `Available for products deliver to ${
                is_ds == 1
                  ? is_fbk == 1 || is_gs == 1
                    ? "local dispatch/"
                    : "local dispatch"
                  : ""
              } ${is_fbk == 1 ? (is_gs == 1 ? "Kilimall/" : "Kilimall") : ""} ${
                is_gs == 1 ? "oversea shipment" : ""
              }and fulfilled by ${
                is_delivery == 1
                  ? is_kili_agent == 1 || is_other_pick == 1
                    ? "Doorstep/"
                    : "Doorstep"
                  : ""
              } ${
                is_kili_agent == 1
                  ? is_other_pick == 1
                    ? "Kilishop/"
                    : "Kilishop"
                  : ""
              } ${is_other_pick == 1 ? "G4S" : ""} `;
            }
          }
        }
      } else if (item.value.voucher_type == 1) {
        //平台满减金额劵
        return (
          "Available above " +
          currencyUnit +
          parseInt(item.value.voucher_limit) +
          " in all stores"
        );
      } else if (item.value.voucher_type == 6) {
        //平台品类满减金额劵
        return `Available above   ${currencyUnit} ${parseInt(
          item.value.voucher_limit
        )} for ${
          item.value.redirect_type_value
            ? item.value.redirect_type_value.gc_name
            : "Kilimall"
        } products  in all stores`;
      } else if (item.value.voucher_type == 2) {
        return `Available above ${ currencyUnit } ${ parseInt(item.value.voucher_limit )} in airtime`
      }else if (item.value.voucher_type == 7) {
        // 流量券 
        return `Available above ${ currencyUnit } ${ parseInt(item.value.voucher_limit )} in Data`
      }
    });

    return {
      get_coupons_title_fn,
      get_coupons_title_fns,
      get_coupons_content_fn,
      get_coupons_content_fns,
      securities_func,
      preserve,
      click_coupons_fn,
      get_voucher_type_name,
    };
  },
};
